// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.answer-image {
    margin: auto;
    object-fit: contain;
    border-radius: 15%;
    max-height: 80vh !important;
    /* min-height: fit-content !important; */
    /* min-width: fit-50 !important; */
    max-width: 80% !important;
    -moz-border-radius: 15%;
    -webkit-border-radius: 15%;
    overflow: hidden;
    /* width: none !important; */
    /* width: 0; */
    /* width: fit-content !important; */
}
.answer-sheet {
    background-color: #bce2e5 !important;
    /* background-image: url("../assets/img/customBackground6.png"); */
}
.data-rsbs-scroll {
    /* background-image: url("../assets/img/customBackground6.png") !important; */
    background-color: #bce2e5 !important;
}
.data-rsbs-overlay:after {
    /* background-image: url("../assets/img/customBackground6.png") !important; */
    background-color: #bce2e5 !important;
}
.data-rsbs-overlay .data-rsbs-root:after {
    /* background-image: url("../assets/img/customBackground6.png") !important; */
}

.data-rsbs-backdrop {
    /* background-image: url("../assets/img/customBackground6.png") !important; */
    background-color: #bce2e5 !important;
}

:root {
    --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);
    /* --rsbs-bg: url("../assets/img/customBackground6.png"); */
    --rsbs-handle-bg: hsla(0, 0%, 0%, 0.14);
    --rsbs-max-w: auto;
    --rsbs-ml: env(safe-area-inset-left);
    --rsbs-mr: env(safe-area-inset-right);
    --rsbs-overlay-rounded: 16px;
}

@media (min-width: 600px) {
    :root {
        --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);
        /* --rsbs-bg: url("../assets/img/customBackground6.png"); */
        --rsbs-handle-bg: hsla(0, 0%, 0%, 0.14);
        --rsbs-max-w: 50% !important;
        --rsbs-ml: env(safe-area-inset-left);
        --rsbs-mr: env(safe-area-inset-right);
        --rsbs-overlay-rounded: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/component/CustomAnswerSheet.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,wCAAwC;IACxC,kCAAkC;IAClC,yBAAyB;IACzB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,oCAAoC;IACpC,kEAAkE;AACtE;AACA;IACI,6EAA6E;IAC7E,oCAAoC;AACxC;AACA;IACI,6EAA6E;IAC7E,oCAAoC;AACxC;AACA;IACI,6EAA6E;AACjF;;AAEA;IACI,6EAA6E;IAC7E,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;IACtC,2DAA2D;IAC3D,uCAAuC;IACvC,kBAAkB;IAClB,oCAAoC;IACpC,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;IACI;QACI,sCAAsC;QACtC,2DAA2D;QAC3D,uCAAuC;QACvC,4BAA4B;QAC5B,oCAAoC;QACpC,qCAAqC;QACrC,4BAA4B;IAChC;AACJ","sourcesContent":[".answer-image {\r\n    margin: auto;\r\n    object-fit: contain;\r\n    border-radius: 15%;\r\n    max-height: 80vh !important;\r\n    /* min-height: fit-content !important; */\r\n    /* min-width: fit-50 !important; */\r\n    max-width: 80% !important;\r\n    -moz-border-radius: 15%;\r\n    -webkit-border-radius: 15%;\r\n    overflow: hidden;\r\n    /* width: none !important; */\r\n    /* width: 0; */\r\n    /* width: fit-content !important; */\r\n}\r\n.answer-sheet {\r\n    background-color: #bce2e5 !important;\r\n    /* background-image: url(\"../assets/img/customBackground6.png\"); */\r\n}\r\n.data-rsbs-scroll {\r\n    /* background-image: url(\"../assets/img/customBackground6.png\") !important; */\r\n    background-color: #bce2e5 !important;\r\n}\r\n.data-rsbs-overlay:after {\r\n    /* background-image: url(\"../assets/img/customBackground6.png\") !important; */\r\n    background-color: #bce2e5 !important;\r\n}\r\n.data-rsbs-overlay .data-rsbs-root:after {\r\n    /* background-image: url(\"../assets/img/customBackground6.png\") !important; */\r\n}\r\n\r\n.data-rsbs-backdrop {\r\n    /* background-image: url(\"../assets/img/customBackground6.png\") !important; */\r\n    background-color: #bce2e5 !important;\r\n}\r\n\r\n:root {\r\n    --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);\r\n    /* --rsbs-bg: url(\"../assets/img/customBackground6.png\"); */\r\n    --rsbs-handle-bg: hsla(0, 0%, 0%, 0.14);\r\n    --rsbs-max-w: auto;\r\n    --rsbs-ml: env(safe-area-inset-left);\r\n    --rsbs-mr: env(safe-area-inset-right);\r\n    --rsbs-overlay-rounded: 16px;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n    :root {\r\n        --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);\r\n        /* --rsbs-bg: url(\"../assets/img/customBackground6.png\"); */\r\n        --rsbs-handle-bg: hsla(0, 0%, 0%, 0.14);\r\n        --rsbs-max-w: 50% !important;\r\n        --rsbs-ml: env(safe-area-inset-left);\r\n        --rsbs-mr: env(safe-area-inset-right);\r\n        --rsbs-overlay-rounded: 16px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
